import { SVGProps, Ref, forwardRef } from 'react';

export const ThumbUpOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.415 8.68c.344-2.448-.32-3.333-2.642-3.405H9.704V3.23c0-1.108-.351-2.1-1.363-2.583-.965-.46-2.06.217-2.143 1.236-.119 1.459-.755 2.671-1.879 4.07h-.183C1.41 5.953.5 6.862.5 9.59v2.273c0 2.728.91 3.637 3.636 3.637h6.932c2.542-.012 3.511-.87 3.868-3.41zM3.699 7.363c-.946.046-1.28.241-1.413.375-.154.153-.386.565-.386 1.852v2.273c0 1.286.232 1.698.385 1.851.135.135.468.33 1.414.376zm1.4 6.737h5.966c1.159-.006 1.61-.213 1.83-.407.223-.197.49-.63.655-1.798l.479-3.41c.166-1.182-.006-1.494-.044-1.544-.007-.008-.178-.23-1.235-.266H8.304V3.23c0-.418-.068-.72-.164-.92a.8.8 0 0 0-.402-.4.1.1 0 0 0-.042-.01.1.1 0 0 0-.046.016c-.043.025-.055.058-.057.08-.15 1.852-.971 3.326-2.182 4.834l-.312.388z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ThumbUpOutlinedSize16Glyph.displayName = 'ThumbUpOutlinedSize16Glyph';
